
<template>
  <div class="loader-container text-center">
    <img :src=img>
  </div>
</template>

<script>
export default {
    name: "Loader",
    props: {
      img: {
        type: String,
        default: require("@/assets/loaderbar.gif")
      }
    },
}
</script>

<style lang="scss" scoped>
  .loader-container{
    width: 100%;
  }
</style>